var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_819_20599)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_819_20599",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_819_20599)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 14.0395V34C44 35.5913 43.3679 37.1174 42.2426 38.2426C41.1174 39.3679 39.5913 40 38 40H10C8.4087 40 6.88258 39.3679 5.75736 38.2426C4.63214 37.1174 4 35.5913 4 34V14C4 13.9996 4 14.0004 4 14C4.00032 12.4091 4.63242 10.8823 5.75736 9.75736C6.88258 8.63214 8.4087 8 10 8H38C39.5913 8 41.1174 8.63214 42.2426 9.75736C43.3553 10.87 43.9858 12.3746 43.9998 13.9466C44.0006 13.9775 44.0006 14.0085 44 14.0395ZM8.58579 12.5858C8.96086 12.2107 9.46957 12 10 12H38C38.5304 12 39.0391 12.2107 39.4142 12.5858C39.5606 12.7322 39.682 12.8989 39.7755 13.0794L24.0002 23.5963L8.22458 13.0792C8.31813 12.8988 8.43945 12.7321 8.58579 12.5858ZM8 17.7369L22.8908 27.6641C23.5626 28.1119 24.4378 28.1119 25.1096 27.6641L40 17.7371V34C40 34.5304 39.7893 35.0391 39.4142 35.4142C39.0391 35.7893 38.5304 36 38 36H10C9.46957 36 8.96086 35.7893 8.58579 35.4142C8.21071 35.0391 8 34.5304 8 34V17.7369Z",
    fill: "#1E293B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_819_20599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.63e943b25b77d040154b35ec50f11d7a.svg";
export { ForwardRef as ReactComponent };